export * from './lib/kanzi-alerts.module';
export * from './lib/alert/alert.service';
export * from './lib/alert-confirm/alert-confirm.service';
export * from './lib/alert-voice/alert-voice.service';
